import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { PLANCONTABLE_MAIN } from 'constants/codigosTransacciones'

import MainPage from './main'

export default function AsientosContablesPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${PLANCONTABLE_MAIN}`} component={MainPage} />
      </Switch>
    </Suspense>
  )
}
